import { track } from '@sloyd/analytics';
import { CheckoutEventNames, openCheckout } from '@sloyd/pay';
import { toast } from '@sloyd/ui';
import { call, delay, fork, takeEvery } from 'saga-ts';
import { invokeEvent, l } from 'shared-base';
import { customEventChannel } from './channels/channel.customEvent';
import { dataGuard } from './helpers/guards';
import { onPurchaseCompleted } from './helpers/purchase.final';

export const saga = {
  id: 'sloyd.purchase',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['PURCHASE'],
  },
};

type Verb =
  | 'plan' //
  | 'credits';

type Action = {
  type: 'PURCHASE';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  plan: purchasePlan,
  credits: purchaseCredits,
};

const analyitcsMapPurchases: any = {
  plan: 'Start Plan Purchase',
};

const analyitcsMapPaddle: Record<CheckoutEventNames, string> = {
  [CheckoutEventNames.CHECKOUT_LOADED]: 'Paddle | Checkout Loaded',
  [CheckoutEventNames.CHECKOUT_CLOSED]: 'Paddle | Checkout Closed',
  [CheckoutEventNames.CHECKOUT_UPDATED]: 'Paddle | Checkout Updated',
  [CheckoutEventNames.CHECKOUT_COMPLETED]: 'Paddle | Checkout Completed',
  [CheckoutEventNames.CHECKOUT_ERROR]: 'Paddle | Checkout Error',
  [CheckoutEventNames.CHECKOUT_FAILED]: 'Paddle | Checkout Failed',
  [CheckoutEventNames.CHECKOUT_ITEMS_UPDATED]: 'Paddle | Checkout Items Updated',
  [CheckoutEventNames.CHECKOUT_ITEMS_REMOVED]: 'Paddle | Checkout Items Removed',
  [CheckoutEventNames.CHECKOUT_CUSTOMER_CREATED]: 'Paddle | Checkout Customer Created',
  [CheckoutEventNames.CHECKOUT_CUSTOMER_UPDATED]: 'Paddle | Checkout Customer Updated',
  [CheckoutEventNames.CHECKOUT_CUSTOMER_REMOVED]: 'Paddle | Checkout Customer Removed',
  [CheckoutEventNames.CHECKOUT_PAYMENT_SELECTED]: 'Paddle | Checkout Payment Selected',
  [CheckoutEventNames.CHECKOUT_PAYMENT_INITIATED]: 'Paddle | Checkout Payment Initiated',
  [CheckoutEventNames.CHECKOUT_PAYMENT_FAILED]: 'Paddle | Checkout Payment Failed',
  [CheckoutEventNames.CHECKOUT_DISCOUNT_APPLIED]: 'Paddle | Checkout Discount Applied',
  [CheckoutEventNames.CHECKOUT_DISCOUNT_REMOVED]: 'Paddle | Checkout Discount Removed',
};

export function* purchasePlan(action: Action) {
  const { id: planId } = action;

  if (planId === 'ENTERPRISE') {
    navigator.clipboard.writeText('support@sloyd.ai');
    track('Enterprise Contact Request');
    toast.show(
      'Our support email has been copied to your clipboard. Feel free to reach out with your inquiry!'
    );
    return;
  }

  try {
    openCheckout(planId as ProductId);
  } catch (err) {
    console.log('err =>', err);
    invokeEvent('sentry', { err });
  }
}

export function* purchaseCredits(_action: Action) {
  try {
    // prompt.confirm({
    //   title: 'Issue with The Credits Store',
    //   description:
    //     'There seems to be an ongoing issue with the credits store 🙏. Please email us at support@sloyd.ai for more information.',
    //   ctaButtonText: 'Got it',
    //   hideCancel: true,
    // });
    openCheckout('CREDITS_10' as ProductId);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* onPaddleEvent(ev: any) {
  const { data = {} } = ev;
  const name = data.name as CheckoutEventNames;
  const eventName = (analyitcsMapPaddle as any)[name];

  switch (name) {
    case CheckoutEventNames.CHECKOUT_COMPLETED:
      yield call(onPurchaseCompleted, data as PaddleCheckoutData);

      break;
    case CheckoutEventNames.CHECKOUT_ERROR:
    case CheckoutEventNames.CHECKOUT_FAILED:
    case CheckoutEventNames.CHECKOUT_PAYMENT_FAILED:
      toast.error('Something went wrong. Please try again.');
      break;

    default:
  }

  if (!eventName) return;
  track(eventName, {});
}

export function* purchases(action: any) {
  const { verb, id, origin } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.purchases ${verb} on ${id}`);

  yield* dataGuard();

  track(analyitcsMapPurchases[verb], { origin, id });

  yield* fork(saga, action);
}

export function* root() {
  let channel;

  yield takeEvery('PURCHASE', purchases);

  channel = customEventChannel('PADDLE');
  yield takeEvery(channel, onPaddleEvent);
}
